module.exports = __webpack_public_path__ + "dd534cfde2aa3a5d2fdb1c05e2ac5e8c.jpg";